import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const Container: FC<Props> = ({ children }) => (
  <div className="relative z-0 flex min-h-screen flex-col pt-36 antialiased md:pt-40">
    {children}
  </div>
);
